module.exports = __webpack_public_path__ + "static/media/CenturyGothicRegular.d250f8c8.svg";